import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { MobileLeadFormSection } from './mobile/MobileLeadFormSection';

interface LeadFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  listingId: string;
  listingLabel?: string;
  referenceCode?: string;
  listingKind?: 'property' | 'plot' | 'project';
  property?: any;
}

export function LeadFormDialog({ open, onOpenChange, listingId, listingLabel, referenceCode, listingKind, property }: LeadFormDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md p-0 overflow-hidden max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <DialogHeader className="px-4 pt-4">
          <DialogTitle className="sr-only">Send a Message</DialogTitle>
        </DialogHeader>
        <div className="p-2">
          <MobileLeadFormSection
            listingId={listingId}
            listingLabel={listingLabel}
            referenceCode={referenceCode}
            listingKind={listingKind}
            property={property}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
